/*
 * Fig & Bloom - product card delivery cookie helper and add-to-cart gate.
 *
 * This was previously emitted inline once per product card, 50 times on a collection page,
 * 8,252 bytes each, byte-identical. It sits on the add-to-cart path: on DOMContentLoaded it
 * attaches a submit handler to EVERY '.single-variant-form' it can find, so 50 copies meant
 * every add-to-cart form carried 50 distinct submit listeners. They are separate closures,
 * so the browser did not dedupe them and a missing delivery date fired 50 alerts. That was a
 * live add-to-cart bug, not only a performance cost.
 *
 * Loaded once per page from snippets/product-card-scripts.liquid.
 */
(function () {
  if (window.__fbProductCardDeliveryLoaded) return;
  window.__fbProductCardDeliveryLoaded = true;

(function() {
  // Helper function to get cookie value
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // getCookie above returns the raw (encoded) value; the guard wants it decoded.
  function safeDecode(value) {
    if (!value) return '';
    try { return decodeURIComponent(value); } catch (e) { return value; }
  }

  function getDeliveryDate() { return getCookie('DeliveryDate'); }
  function getDeliveryDateISO() { return getCookie('ISODate'); }

  // Helper function to determine location from postcode
  function findPostcodeLocation(userSelectedPostcode) {
    // P3 cutover: prefer the dynamic all-locations resolver (adds Adelaide etc.).
    // Returns null when no/partial consolidated config -> fall through to legacy.
    var dyn = window.fbResolvePostcode && window.fbResolvePostcode(userSelectedPostcode);
    if (dyn) return dyn;

    if (typeof brisbanePostcodes === 'undefined') return "Unknown Location";
    
    var brisbanePostcodesArray = brisbanePostcodes.Postcodes[0].split(',');
    var melbournePostcodesArray = melbournePostcodes.Postcodes[0].split(',');
    var sydneyPostcodesArray = SydneyPostcodes.Postcodes[0].split(',');
    var restOfAustraliaPostcodesArray = RestofAustraliaPostcodes.Postcodes[0].split(',');

    function matchesPattern(pattern, postcode) {
      if (pattern.endsWith('*')) {
        let prefix = pattern.slice(0, -1);
        return postcode.startsWith(prefix);
      } else if (pattern.includes(',')) {
        return pattern.split(',').includes(postcode);
      } else {
        return pattern === postcode;
      }
    }

    let postcodeStr = userSelectedPostcode.toString();

    if (brisbanePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
      return "Brisbane";
    } else if (melbournePostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
      return "Melbourne";
    } else if (sydneyPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
      return "Sydney";
    } else if (restOfAustraliaPostcodesArray.some(pattern => matchesPattern(pattern, postcodeStr))) {
      return "RestofAustralia";
    } else {
      return "Unknown Location";
    }
  }

  // Candidate attribute suffixes for a resolved location: legacy slug first
  // (melbourne/brisbane/sydney/rest-australia — note ROA's is NOT its lowercased
  // keyPrefix), then the lowercased keyPrefix that fb-location-date-attrs.liquid
  // emits for every configured location. Same helper as product-form.js.
  function fbDateAttrSuffixes(location) {
    const legacy = { 'Melbourne': 'melbourne', 'Brisbane': 'brisbane', 'Sydney': 'sydney', 'RestofAustralia': 'rest-australia' }[location];
    const out = [];
    if (legacy) out.push(legacy);
    if (location) {
      const lower = String(location).toLowerCase();
      if (out.indexOf(lower) === -1) out.push(lower);
    }
    return out;
  }

  // Helper function to check if pre-sale is enabled for current location
  function isPreSaleEnabledForCurrentLocation(container) {
    if (!container) return false;

    const selectedPostcode = getCookie('deliveryPostcode');
    if (!selectedPostcode) return false;

    const location = findPostcodeLocation(selectedPostcode);

    // P5: resolve the pre-sale flag with the SAME suffix list the display side
    // already uses — the rendering surfaces and fb-location-date-attrs.liquid emit
    // data-pre-sale-{location} for every location, but this reader was still a
    // four-city switch with `default: return false`, so a 5th city could be BADGED
    // "Pre-Sale" while this handler treated it as an ordinary add. Legacy suffix is
    // tried first, so the original four are byte-identical to the old switch.
    // (Same fix as isPreSaleEnabledForCurrentLocation in product-form.js, 8305f17.)
    const suffixes = fbDateAttrSuffixes(location);
    for (let i = 0; i < suffixes.length; i++) {
      if (container.getAttribute('data-pre-sale-' + suffixes[i]) === 'true') {
        return true;
      }
    }
    return false;
  }

  // Bind every single-variant form that is not already bound.
  //
  // The data-fb-delivery-bound guard is what makes this safe to call repeatedly. It mirrors
  // the ':not(.swiper-initialized)' guard the swiper initialiser uses, and it is the reason
  // this can now run on AJAX grid updates as well as on load: cards added by infinite scroll
  // or Load More previously got no submit handler at all, because the inline copies had
  // already run their DOMContentLoaded pass by the time those cards arrived.
  function bindSingleVariantForms() {
    const singleVariantForms = document.querySelectorAll('.single-variant-form:not([data-fb-delivery-bound])');

    singleVariantForms.forEach(form => {
      form.setAttribute('data-fb-delivery-bound', 'true');
      form.addEventListener('submit', function(e) {
        // Get the product container to check pre-sale status
        const productContainer = this.closest('[data-product-id]');
        const productId = productContainer ? productContainer.getAttribute('data-product-id') : null;

        // Get delivery data from cookies
        const deliverySuburb = getCookie('deliverySuburb') || '';
        const deliveryPostcode = getCookie('deliveryPostcode') || '';
        let deliveryDate = getDeliveryDate() || '';
        let deliveryDateISO = getDeliveryDateISO() || '';

        // A date before today is not a delivery date. Clear it (the guard in
        // snippets/fb-delivery-date-guard.liquid keeps the suburb/postcode) and
        // treat it as missing, so the popup below opens at the date step.
        const dateGuard = window.fbDeliveryDate;
        if (deliveryDate && dateGuard && dateGuard.isPast(safeDecode(deliveryDateISO), safeDecode(deliveryDate))) {
          // clearStale() keeps a newer copy that was hiding behind the past one
          // (a duplicate cookie in another scope), so read again after it.
          dateGuard.clearStale();
          deliveryDate = getDeliveryDate() || '';
          deliveryDateISO = getDeliveryDateISO() || '';
          if (deliveryDate && dateGuard.isPast(safeDecode(deliveryDateISO), safeDecode(deliveryDate))) {
            deliveryDate = '';
            deliveryDateISO = '';
          }
        }
        
        
        const centrepieceLead = window.fbCentrepieceLeadTime;
        if (centrepieceLead && (centrepieceLead.isProduct(productId) || centrepieceLead.applies(productId))
            && (!deliveryDate || centrepieceLead.invalidDate(safeDecode(deliveryDateISO), safeDecode(deliveryPostcode), productId))) {
          // Keep the intended product while the ordinary popup chooses its date.
          window.pendingDeliveryAdd = { form: this, getProductId: function () { return productId; } };
        }
        if (centrepieceLead && centrepieceLead.refuse(productId)) {
          e.preventDefault();
          return false;
        }

        // Check if pre-sale is enabled for the CURRENT location (not just any location)
        const isPreSaleEnabledForLocation = isPreSaleEnabledForCurrentLocation(productContainer);
        
        if (isPreSaleEnabledForLocation) {
          e.preventDefault(); // Always prevent default for pre-sale products
          
          // Check if delivery location is selected
          if (!deliverySuburb || !deliveryPostcode) {
            alert('Please select your delivery suburb first.');
            // Open popup at location step
            if (typeof openPopupAtStep === 'function') {
              openPopupAtStep('location');
            }
            return false;
          }
          
          // For pre-sale products, always show date selection popup
          // Store the form reference for later submission
          window.pendingPreSaleForm = this;
          
          // Open popup directly to date selection with pre-sale message
          if (typeof openPreSalePopup === 'function') {
            openPreSalePopup(productId);
          } else if (typeof openPopupAtStep === 'function') {
            openPopupAtStep('date');
          }
          return false;
        }
        
        // Regular product logic (non-pre-sale or pre-sale not enabled for current location)
        if (!deliverySuburb || !deliveryPostcode || !deliveryDate) {
          e.preventDefault();
          
          // Open the popup
          if (typeof openPopup === 'function') {
            openPopup();
            
            // If no location is selected, start from location step
            if (!deliverySuburb || !deliveryPostcode) {
              setTimeout(function() {
                if (typeof resetToLocationStep === 'function') {
                  resetToLocationStep();
                }
              }, 100);
            } else {
              // If location exists but no date, go to date step
              setTimeout(function() {
                if (typeof popupSetupDatePicker === 'function') {
                  popupSetupDatePicker(deliverySuburb, getCookie('deliveryState'), deliveryPostcode);
                }
              }, 100);
            }
          } else {
            // Fallback to alert if popup function doesn't exist
            alert('Please select your delivery suburb and date before adding to cart.');
          }
          
          return false;
        }
        
        // Update the hidden inputs with cookie values for regular products
        const suburbInput = this.querySelector('.delivery-suburb-property');
        const postcodeInput = this.querySelector('.delivery-postcode-property');
        const dateInput = this.querySelector('.delivery-date-property');
        const dateISOInput = this.querySelector('.delivery-date-iso-property');
        
        if (suburbInput) suburbInput.value = deliverySuburb;
        if (postcodeInput) postcodeInput.value = deliveryPostcode;
        if (dateInput) dateInput.value = deliveryDate;
        if (dateISOInput) dateISOInput.value = deliveryDateISO;

      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSingleVariantForms);
  } else {
    bindSingleVariantForms();
  }

  // Re-bind for cards added after load by infinite scroll, Load More, or a section reload.
  document.addEventListener('ajaxProductGridUpdated', bindSingleVariantForms);
  document.addEventListener('shopify:section:load', bindSingleVariantForms);
})();
})();
